import React, { useState } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import AutoComplete from '../AutoComplete';
import ModalDropdown from '../ModalDropdown';
import { Input } from '../FormInputs';
import PropTypes from 'prop-types';
import { ReactComponent as ChevronDownIcon } from 'images/at_chevron-down.svg';

const DropdownSelect = ({
    label,
    name,
    placeholder,
    options = [],
    value,
    onChange,
    onSelect,
    error,
    helperText,
    isFullScreen = false,
    title,
    disabled,
    disableCustomValue = false,
    ...props
}) => {
    const [open, setOpen] = useState(false);
    const isSmallScreen = useMediaQuery('(max-width: 768px)');

    const handleChange = (event) => {
        onChange(event);
    };

    const handleSelect = (option) => {
        onSelect(option);
        setOpen(false);
    };

    const handleInputClick = () => setOpen(!disabled);

    return (
        <Box>
            {isSmallScreen ? (
                <Box>
                    <Input
                        label={label}
                        name={name}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        onClick={handleInputClick}
                        error={error}
                        helperText={helperText}
                        disabled={disabled}
                        EndAdornmentIcon={ChevronDownIcon}
                        readOnly={true}
                        {...props}
                    />
                    <ModalDropdown
                        open={open}
                        setOpen={setOpen}
                        isFullScreen={isFullScreen}
                        title={title}
                        name={name}
                        placeholder={placeholder}
                        options={options}
                        value={value}
                        onChange={handleChange}
                        onSelect={handleSelect}
                        error={error}
                        helperText={helperText}
                        onSelectItem={handleSelect}
                        allowCustomValue={!disableCustomValue}
                    />
                </Box>
            ) : (
                <AutoComplete
                    label={label}
                    name={name}
                    placeholder={placeholder}
                    options={options}
                    value={value}
                    onChange={handleChange}
                    onSelect={handleSelect}
                    error={error}
                    helperText={helperText}
                    disabled={disabled}
                    disableCustomValue={disableCustomValue}
                    {...props}
                />
            )}
        </Box>
    );
};

DropdownSelect.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    helperText: PropTypes.string,
    isFullScreen: PropTypes.bool,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func,
    title: PropTypes.string,
    disableCustomValue: PropTypes.bool,
};

export default DropdownSelect;
